@import (reference) '../../../../../constants/spacing.module.less';

.placeholder {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.activate-returns-image {
  max-height: 320px;
}

.details-image {
  max-height: 180px;
}

.header {
  display: flex;
  max-width: 650px;
  flex-direction: column;
  align-items: center;
  gap: @space-8;
  margin-top: @space-32;
  margin-bottom: @space-32;
}

.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: @space-16;
}

.buttons {
  display: flex;
  align-items: flex-start;
  gap: @space-16;
}

.ctaButton {
  > svg {
    height: @space-16;
    width: @space-16;
    margin-left: @space-8;
  }
}
